import { render, staticRenderFns } from "./ParentFormModel.vue?vue&type=template&id=58facc2d&scoped=true&"
import script from "./ParentFormModel.vue?vue&type=script&lang=js&"
export * from "./ParentFormModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58facc2d",
  null
  
)

export default component.exports